// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions" formulaire="vm.formulaire"></ex-mono-occurrence-ecran> `;
// Exports
module.exports = code;